import { useEffect, useState } from 'react'
import { useModal } from '../../hooks';
import LavorisService from '../../services/LavorisService';
import { useAlert } from '../../hooks/useAlert';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/combineReducer';
import { SelectedFiles } from '../../components/others/FileUploader/FileUploader.types';
import { useForm } from 'react-hook-form';
import { getErrorMessage } from '../../utils';
import { Modal } from '../../components/others/Modal';
import { PhoneNumber } from '../../utils/phoneNumber';
import SearchSelectFetch from '../../components/others/SearchFetch';
import { fetchAndFilterMoldes, fetchAndFilterPractices } from '../others/requestTurn/utils';
import { PillButton } from '../../components/others/PillButton';
import Textarea from '../../components/others/Textarea/Textarea';
import FileUpload from '../../components/others/FileUploader/FileUploader';
import { PrimaryButton } from '../../components/others/ButtonPrimary';
import { ExamDetails, MoldeDetails, PracticesPillows } from '../others/AppointmentMetadata';
import { Practice } from '../../services/TurnServices/Turns.type';
import { UpdatePersonalDataModal } from './UpdatePersonalDataModal';
import { SearchSelect } from '../../components/others/SearchSelect';
import { useSelectData } from '../../hooks/useSelectData';
import { Pillows } from '../../components/others/Pillows';
import { SuccessModal } from '../../components/others/SuccessModal';

const UPDATE_PERSONAL_DATA_MODAL = 'updatePersonalDataModal';
const APPLICANTS_MULTIPLE_REQUEST_TURN_MODAL = 'applicantsMultipleRequestTurnModal';
const SUCCESS = 'succesPetition';

const NewRequestsMultipleApplicantsModal = (props: any) => {
    const LavorisInstance = LavorisService.getInstance();
    const { showAlert } = useAlert();
    const { isActive, closeModal, openModal } = useModal();
    const currentCompany = useSelector((state: RootState) => state.user.currentCompany || state.user.companies[0]?.id);
    const styles = "text-2xl text-red-500 font-bold";
    const [type, setType] = useState<string>('Postulante')
    const [usersFound, setUsersFound] = useState<any | any[]>(null)
    const [selectedEmployee, setSelectedEmployee] = useState<any>(null);
    const [selectedFiles, setSelectedFiles] = useState<SelectedFiles | null>(null,);
    const [requestLoading, setRequestLoading] = useState<boolean>(false);
    const [updateEmailPhoneData, setUpdateEmailPhoneData] = useState<{ email: string, phoneNumber: string, name: string }>({ email: "", phoneNumber: "", name: "", });
    const [isSubmitted, setIsSubmitted] = useState(false);


    const url = 'company/admin/candidates/multiplerequest';
    const [query, setQuery] = useState(""); // Estado para la query de búsqueda avanzada
    const [searchInput, setSearchInput] = useState(""); // Estado para el valor del input de búsqueda avanzada
    const [AllApplicants, setAllApplicants] = useState<any[]>([]); // Estado para los postulantes
    const [openSearch, setOpenSearch] = useState<boolean>(false); // Controla si se muestra la búsqueda avanzada
    const [applicantsFound, setApplicantsFoud] = useState<boolean>(false); //
    const [onSearchLoading, setOnSearchLoading] = useState<boolean>(false); //
    const {
        data: applicants,
        helpers: { itemsSelected: selectedApplicants, onUnSelected, onSelect },
    } = useSelectData(url, false);

    const getApplicantsFistCall = async () => {
        setApplicantsFoud(false)
        const applicants = await LavorisInstance.CompanyServices.getAllApplicantsQuery("");
        if (!applicants) return;
        setAllApplicants(applicants);
        setApplicantsFoud(false)
    };
    useEffect(() => {
        getApplicantsFistCall()
    }, []);

    useEffect(() => {

        const getApplicants = async () => {
            try {
                const applicants = await LavorisInstance.CompanyServices.getAllApplicantsQuery(query);
                if (applicants.length === 0) {
                    setApplicantsFoud(false)
                    getApplicantsFistCall()
                    showAlert('No se encontró un Postulante con esos datos')
                };
                setApplicantsFoud(true)
                setAllApplicants(applicants);
            } catch (error) {
                console.log(error);
            } finally {
                setOnSearchLoading(false);
            }
        };
        if (query) {
            setOnSearchLoading(true)
            getApplicants();
        }
    }, [query]);

    // Función que maneja la apertura de la búsqueda avanzada
    const handleOpenSearch = () => {
        setOpenSearch(true);
    };

    // Función que maneja el clic en el botón "Buscar"
    const handleSearch = () => {
        setQuery(searchInput);
    };

    // Función que maneja el cierre de la búsqueda avanzada
    const handleCloseSearch = () => {
        setOpenSearch(false);
        setQuery("");
        getApplicantsFistCall()
    };


    const {
        register,
        handleSubmit,
        resetField,
        setValue,
        control,
        watch,
        reset,
        formState: { errors }
    } = useForm({
        mode: 'all'
    });

    const [patient, molde, exam, practicesSelected] = watch([
        'patient',
        "molde",
        "exam",
        "practicesSelected",
    ]);

    useEffect(() => {
        const normalizeString = (str: any) => {
            return str
                .trim()
                .replace(/\s+/g, ' ')
                .toLowerCase();
        };

        const chosenEmployee = usersFound?.find((e: any) => {
            const ename = e?.name?.split(',')[1]?.trim();
            const elastname = e?.name?.split(',')[0]?.trim();
            const efullname = `${elastname}, ${ename}`;

            const pname = patient?.split(',')[1]?.trim();
            const plastname = patient?.split(',')[0]?.trim();
            const pfullname = `${plastname}, ${pname}`;
            return normalizeString(efullname) === normalizeString(pfullname);
        });
        setSelectedEmployee(chosenEmployee);
    }, [patient]);

    const updateUploadedFiles = (files: File[]) =>
        setSelectedFiles({ ...selectedFiles, profileImages: files });

    const uploadFile = async (id: string, selectedFile: File) => {
        await LavorisInstance.TurnServices.addFile(
            { file: selectedFile },
            id,
        ).catch((e: any) => console.log(e));
    };

    // OnSubmit
    const onSubmit = async (data: any) => {
        setRequestLoading(true);
        try {
            const metadata = {
                exam: exam?.id,
                molde: molde?.id,
                practices: practicesSelected?.map((p: Practice) => p.id),
            };

            if ((metadata.exam === undefined && metadata.molde === undefined) && (metadata.practices === undefined || metadata.practices.length === 0)) {
                showAlert('Debe elegir un examen o una práctica para continuar')
                return;
            }

            const applicantsIds = selectedApplicants?.map((p: any) => p.alias)

            const patientType = 'COMPANY_CANDIDATE';
            const dataToSubmit = {
                observations: data.comments,
                patientType,
                patientsIds: applicantsIds,
                metadata,
            };

            const res = await LavorisInstance.TurnServices.RequestMultipleTurnService(dataToSubmit)

            if (res?.appointmentsId?.length > 0 && selectedFiles?.profileImages[0]) {
                await Promise.all(
                    res.appointmentsId.map((appointmentid) =>
                        uploadFile(
                            appointmentid,
                            selectedFiles.profileImages[0],
                        )
                    )
                );
            }

            // props?.onClose();
            closeModal(APPLICANTS_MULTIPLE_REQUEST_TURN_MODAL)
            openModal(SUCCESS);
        } catch (err) {
            console.log(err);
            showAlert(getErrorMessage({ title: 'NO SE PUDO REALIZAR LA SOLICITUD.', err }))
        } finally {
            setRequestLoading(false);
        }
    };

    useEffect(() => {
        if (isSubmitted) {
            setSelectedEmployee({
                ...selectedEmployee,
                email: updateEmailPhoneData.email,
                phoneNumber: updateEmailPhoneData.phoneNumber,
                name: updateEmailPhoneData.name,
            })
            setIsSubmitted(false);
        }

    }, [isSubmitted])

    if (AllApplicants.length === 0) {
        return (
            <Modal
                show={props.show}
                modalTitle={props.modalTitle}
                urlTittle={props.urlTittle}
                onClose={props.onClose}
                titleStyle={styles}
            >
                <h1 className="w-full flex justify-center animate-pulse text-red-500 text-xl">
                    Cargando postulantes...
                </h1>
            </Modal>
        )
    }

    return (
        <>
            <Modal
                show={props.show}
                modalTitle={props.modalTitle}
                urlTittle={props.urlTittle}
                onClose={props.onClose}
                titleStyle={styles}
                modalContainerStyle="max-h-[95vh]"
            >
                <div className="overflow-y-auto max-h-[90vh] px-5 pt-3 min-width-modal">
                    <form className='flex flex-col gap-3' onSubmit={handleSubmit(onSubmit)}>
                        <div className='flex flex-col gap-2 justify-start align-middle position-relative min-h-[300px]'>
                            {!openSearch &&
                                <div className='flex gap-2'>
                                    <span className=''>El selector trae los últimos 20 postulantes creados, si no los encuentra en las opciones haga click </span>
                                    <span className='undeline font-extrabold cursor-pointer' onClick={handleOpenSearch}>AQUI</span>
                                </div>}
                            {openSearch && (
                                <div className="flex gap-2 items-center">
                                    <input
                                        type="text"
                                        value={searchInput}
                                        onChange={(e) => setSearchInput(e.target.value)}
                                        placeholder="Ingrese apellido, nombre o dni"
                                        className="py-2 rounded border border-gray-300 p-2"
                                    />
                                    <button type='button' onClick={handleSearch} className={`bg-blue-500 text-white rounded px-4 py-2 ${onSearchLoading ? 'animate-pulse text-red-500' : ""}`}>
                                        {onSearchLoading ? 'Buscando' : 'Buscar'}
                                    </button>
                                    <button type='button'
                                        onClick={() => {
                                            setSearchInput("");
                                            setQuery("");
                                            handleCloseSearch();
                                        }}
                                        className="bg-red-500 text-white rounded px-4 py-2">
                                        Cerrar búsqueda
                                    </button>
                                </div>
                            )}
                            {applicantsFound && <span className='animate-pulse text-red-500'>***</span>}
                            <SearchSelect
                                fieldName="applicants"
                                options={AllApplicants
                                    .filter((applicant) => {
                                        const isSelected = selectedApplicants.find((selectedApplicant) => selectedApplicant.alias === applicant.id);
                                        return !isSelected; // Solo muestra los que no están seleccionados
                                    })
                                    .map((applicant) => ({
                                        label: `Nombre: ${applicant.name} - DNI: ${applicant.DNI} - Email: ${applicant.email} - Tel: ${PhoneNumber(applicant.phoneNumber)}`,
                                        value: applicant.id,
                                    }))
                                }
                                label="Seleccionar postulantes"
                                onSelect={(option) =>
                                    onSelect({
                                        alias: option.value as string,
                                        name: option.label as string,
                                    })
                                }
                                customKey={selectedApplicants?.length} // Refresca la lista cuando se selecciona un candidato
                                styles="rounded h-[80px]"
                                error={errors?.applicants}
                            />
                        </div>
                        {selectedApplicants?.length > 0 && (
                            <div className="mb-4 max-w-lg">
                                <Pillows
                                    chosenPractices={selectedApplicants?.map(
                                        (applicant) => applicant.name,
                                    )}
                                    handleDelete={onUnSelected}
                                />
                            </div>
                        )}
                        {
                            selectedApplicants.length > 0 && (
                                <>

                                    <div className="my-5">
                                        <SearchSelectFetch
                                            control={control}
                                            name="molde"
                                            label="Prácticas según puesto"
                                            disabled={Boolean(exam)}
                                            fetchOptions={async () => {
                                                return fetchAndFilterMoldes(
                                                    LavorisInstance,
                                                    currentCompany?.id,
                                                    type,
                                                );
                                            }}
                                            propertyLabel={"name"}
                                            inputStyles="rounded w-full h-[50px]"
                                        />
                                        {molde && (
                                            <div className="my-5">
                                                <div className="mb-6">
                                                    <PillButton
                                                        text={molde.name || molde.position.name}
                                                        onClick={() => resetField("molde")}
                                                    />
                                                </div>
                                                <MoldeDetails molde={molde} />
                                            </div>
                                        )}
                                    </div>
                                    <SearchSelectFetch
                                        control={control}
                                        name="exam"
                                        label="Examen"
                                        fetchOptions={async () =>
                                            LavorisInstance.ExamsMoldes.getExamsWithPracticesDataFilteredByPatientType(
                                                type,
                                            )
                                        }
                                        propertyLabel={"name"}
                                        inputStyles="rounded w-full h-[50px]"
                                        disabled={Boolean(molde)}
                                    />
                                    {exam && (
                                        <div className="mb-6">
                                            <div className="mb-6">
                                                <PillButton
                                                    key={`exam-${exam.id}`}
                                                    text={exam.name}
                                                    onClick={() => resetField("exam")}
                                                />
                                            </div>
                                            <ExamDetails exam={exam} />
                                        </div>
                                    )}

                                    <SearchSelectFetch
                                        control={control}
                                        name="practiceSelector"
                                        label="Prácticas individuales"
                                        fetchOptions={async () => {
                                            return fetchAndFilterPractices(
                                                LavorisInstance,
                                                exam,
                                                molde,
                                                practicesSelected,
                                                type
                                            );
                                        }}
                                        propertyLabel={"name"}
                                        inputStyles="rounded w-full h-[50px]"
                                        onSelected={(data) => {
                                            const selected = practicesSelected?.length
                                                ? practicesSelected
                                                : [];
                                            setValue("practicesSelected", [...selected, data]);
                                        }}
                                    />
                                    {practicesSelected?.length >= 0 && (
                                        <PracticesPillows
                                            practices={practicesSelected}
                                            onClick={(practice: Practice) => {
                                                setValue(
                                                    "practicesSelected",
                                                    practicesSelected.filter((p: any) => p.id !== practice.id),
                                                );
                                            }}
                                        />
                                    )}

                                    <Textarea
                                        fieldName="comments"
                                        label="Comentarios"
                                        register={register}
                                        error={errors?.comments}
                                        styles="rounded w-full mb-4"
                                        rows={8}
                                    />
                                    <FileUpload
                                        label="Cargar archivo (Opcional)"
                                        updateFilesCb={updateUploadedFiles}
                                        maxFileSizeInBytes={500000}
                                        accept="image/jpeg,image/jpg,image/png,image/gif,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                    //multiple
                                    />

                                    <div className="w-52 m-auto">
                                        <PrimaryButton
                                            type="submit"
                                            text={'Solicitar turno'}
                                            styles="bg-red-500 font-bold text-white mt-3"
                                            disabled={requestLoading}
                                        />
                                    </div>
                                </>

                            )
                        }


                    </form>
                </div>
            </Modal >

            {isActive(UPDATE_PERSONAL_DATA_MODAL) && (
                <UpdatePersonalDataModal
                    show
                    urlTittle={UPDATE_PERSONAL_DATA_MODAL}
                    onClose={() => closeModal(UPDATE_PERSONAL_DATA_MODAL)}
                    modalTitle={"Actualizar Nombre, Email o Teléfono"}
                    user={selectedEmployee}
                    setUpdateEmailPhoneData={setUpdateEmailPhoneData}
                    submit={setIsSubmitted}
                />
            )}

            {isActive(SUCCESS) && (
                <SuccessModal
                    show
                    urlTittle={SUCCESS}
                    modalTitle={'SOLICITUD CREADA EXITOSAMENTE.'}
                    modalSubtitle={'Podras consultarla a través de la solapa "Solicitudes"'}
                    onClose={() => { closeModal(SUCCESS) }}
                />
            )}
        </>
    )
}

export default NewRequestsMultipleApplicantsModal